import React from 'react';
import {Row, Col, BackTop} from 'antd';
import {inject, observer} from 'mobx-react';
const store = ['homeStore', 'listStore'];
@inject(...store)
@observer
class App extends React.Component {
  render() {
    let {listStore, location, layout: propsLayout} = this.props;
    const {routing} = listStore;
    const {pathname} = location;
    const isSearch = location.pathname === 'app/search';
    const layout = propsLayout ? propsLayout :{
      span: 20,
      offset: 2
    }
    return (
      <div style={{ paddingTop: isSearch ? 0 : 61 }}>
        <Row style={{backgroundColor: '#f0f4f8', position: 'relative'}}>
          <Col {...layout}>
            {this.props.children}
          </Col>
        </Row>
        {/* <Row style={{backgroundColor: '#f0f4f8', position: 'relative'}}>
          <Col span={18} offset={2}>
            {this.props.children}
          </Col>
          <Col span={4}>
            <div className='cs-left-menu-card'>
              <ul className="cs-left-menu">
                <li>
                  <span className='icon-Cloud-Collection cs-left-menu-icon'/>
                  <span className='cs-left-menu-text' onClick={() => {

                    routing.push({
                      pathname: '/app/collect',
                      query: {
                        id: location.query.id,
                        radioType: location.query.radioType,
                        radioItem: location.query.radioItem,
                        radioSubItem: location.query.radioSubItem,
                      }
                    });
                  }}>我的收藏</span>
                </li> */}
                {/* <li>*/}
                {/*<span className='icon-Cloud-Project cs-left-menu-icon'/>*/}
                {/*<span className='cs-left-menu-text' onClick={() => {*/}
                {/*routing.push({*/}
                {/*pathname: '/app/project',*/}
                {/*query: {*/}
                {/*id: location.query.id,*/}
                {/*application: location.query.application,*/}
                {/*radioType: location.query.radioType,*/}
                {/*radioItem: location.query.radioItem,*/}
                {/*project:location.query.project || '0',*/}
                {/*scheme:location.query.scheme || '0',*/}
                {/*list:location.query.list || '0',*/}
                {/*}*/}
                {/*});*/}
                {/*}}>我的项目</span>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*<span className='icon-Cloud-Programme cs-left-menu-icon'/>*/}
                {/*<span className='cs-left-menu-text' onClick={() => {*/}
                {/*routing.push({*/}
                {/*pathname: '/app/scheme',*/}
                {/*query: {*/}
                {/*id: location.query.id,*/}
                {/*application: location.query.application,*/}
                {/*radioType: location.query.radioType,*/}
                {/*radioItem: location.query.radioItem,*/}
                {/*project:location.query.project || '0',*/}
                {/*scheme:location.query.scheme || '0',*/}
                {/*list:location.query.list || '0',*/}
                {/*}*/}
                {/*});*/}
                {/*}}>我的方案</span>*/}
                {/*</li> */}
                {/* <li>
                  <span className='icon-Cloud-Order cs-left-menu-icon'/>
                  <span className='cs-left-menu-text' onClick={() => {
                    routing.push({
                      pathname: '/app/order',
                      query: {
                        id: location.query.id,
                        radioType: location.query.radioType,
                        radioItem: location.query.radioItem,
                        radioSubItem: location.query.radioSubItem,
                      }
                    });
                  }}>我的订单</span>
                </li>
              </ul>
              <BackTop style={{position:'absolute',top:110,left:-1}} visibilityHeight={600}>
                <div className='back-top'>
                  <span className='icon-Cloud-Top'></span>
                  回到顶部
                </div>
              </BackTop>
            </div>
          </Col>
        </Row> */}
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/util/AppDatasBody.js